import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageBlindreviewComponent } from './page.blindreview/page.blindreview.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageRecruitmentsOffersComponent } from './page.recruitments.offers/page.recruitments.offers.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageRecruitmentsComponent } from './page.recruitments/page.recruitments.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PageRecruitmentsItemComponent } from './page.recruitments.item/page.recruitments.item.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PageRecruitmentsTasksComponent } from './page.recruitments.tasks/page.recruitments.tasks.component';
import { PageRecruitmentsPipelineComponent } from './page.recruitments.pipeline/page.recruitments.pipeline.component';
import { PageRecruitmentsRejectionsComponent } from './page.recruitments.rejections/page.recruitments.rejections.component';
import { PageMyinterviewsComponent } from './page.myinterviews/page.myinterviews.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PageApplicantsItemComponent } from './page.applicants.item/page.applicants.item.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageApplicantsComponent } from './page.applicants/page.applicants.component';
import { PageMytasksComponent } from './page.mytasks/page.mytasks.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalSeasonLoadingDefaultComponent,
        PageMembersComponent,
        PortalPostListComponent,
        PageBlindreviewComponent,
        LayoutEmptyComponent,
        PortalSeasonTreeComponent,
        PortalSeasonPaginationComponent,
        PortalSeasonFormDropdownComponent,
        PageRecruitmentsOffersComponent,
        PageDashboardComponent,
        PageRecruitmentsComponent,
        ComponentNavSidebarComponent,
        PageRecruitmentsItemComponent,
        PageAccessComponent,
        LayoutSidebarComponent,
        PageMypageComponent,
        PageRecruitmentsTasksComponent,
        PageRecruitmentsPipelineComponent,
        PageRecruitmentsRejectionsComponent,
        PageMyinterviewsComponent,
        PortalSeasonLoadingSeasonComponent,
        PagePostsComponent,
        PageApplicantsItemComponent,
        PagePostsItemComponent,
        PortalPostDetailComponent,
        PageApplicantsComponent,
        PageMytasksComponent,
        PortalSeasonModalComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }